// eslint-disable-next-line no-unused-vars
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Form, TextAreaLabel } from '@weezevent/nacre';
import Style from './textAreaInput.module.css';

export default function TextAreaInput({ label, value = '', onChange = () => {}, ...params }) {
    const { t } = useTranslation();

    return (
        <Form.Field>
            <TextAreaLabel
                label={label}
                value={value || ''}
                showLength
                maxlength={params.maxLength ? params.maxLength : 600}
                placeholder={t('ticket.ticket_design.create_design.placeholders.text')}
                className={Style['no-resize_text-area']}
                onChange={e => {
                    onChange(e.target.value);
                }}
                {...params}
            />
        </Form.Field>
    );
}
